import React from 'react'
import Main from './HeadChefDashboard/Main'

function HeadChefDashboard() {
  return (
    <div>
      <Main />
    </div>
  )
}

export default HeadChefDashboard
